export default "__VITE_ASSET__7895ca22__"